(ns frontend.view.modals.entity-audit-trail.view
  (:require
   [common.localization :as loc]
   [common.localization]
   [frontend.view.entity-viewers.activity.events :as events]
   [frontend.view.entity-viewers.activity.history-activity :as history-activity]
   [frontend.zap-time :as zap-time]
   [reagent.core :as r]

   [ui.components.modal.view :as modal]))

(defonce modal-key :entity-audit-trail)

(defn view
  [{:keys [shown? close-modal! props class-name topmost?]}]
  (let [{:keys [primary-entity-id entity-ids title primary-entity-type]} props
        primary-entity-id (or primary-entity-id (first entity-ids))
        state (r/atom {:max-count 50})
        local-entities (r/cursor state [:entities])
        subscription-args {:entity-ids        entity-ids
                           :state             state
                           :primary-entity-id primary-entity-id}]
    (r/create-class
     {:component-did-mount    (fn []
                                (swap! state assoc
                                       :subscribed-ids entity-ids
                                       :last-subscription (zap-time/now))
                                (deref state)
                                (events/open-history-subscription! subscription-args))
      :component-will-unmount (fn []
                                (events/stop-history-subscription! state)
                                (events/stop-audit-subscription! state))
      :reagent-render
      (fn [{:keys [shown? close-modal! props class-name topmost?]}]
        (let [{:keys [on-ok! title]} props]
          [modal/view
           {:visible?      (and shown? topmost?)
            :hide!         close-modal!
            :backdrop      "static"
            :close-button? true}
           title
           [:div
            [history-activity/view primary-entity-id state local-entities primary-entity-type]]
           [:<>
            [modal/left-single-button-hollow
             nil
             false
             (fn [_]
               (close-modal!)
               (when on-ok!
                 (on-ok!)))
             (loc/tr :close)]]]))})))
